import Vue from 'vue'
import Vuex from 'vuex'
import projects from 'reactor-js-core/dist/store/projects'
import meetinglist from 'reactor-js-core/dist/store/meetinglist'
import voting from 'reactor-js-core/dist/store/voting'
import discussion from 'reactor-js-core/dist/store/discussion'
import errors from 'reactor-js-core/dist/store/errors'
import featureset from 'reactor-js-core/dist/store/featureset'
import keyvalues from './keyvalues'
import liststore from 'reactor-js-core/dist/store/liststore'
import entitystore from 'reactor-js-core/dist/store/entitystore'

const env = process.env.NODE_ENV

export default class StoreFactory {
  static createStore(custom_modules, plugins, mutations) {
    if (custom_modules == undefined) custom_modules = {}
    if (plugins == undefined) plugins = []
    if (mutations == undefined) mutations = {}
    let store = new Vuex.Store({
      // run strict mode in development to catch state mutation outside of mutation handlers
      // any attempt to do this results in an error in the console
      strict: env === 'development',
      modules: {
        projects,
        meetinglist,
        voting,
        discussion,
        errors,
        featureset,
        keyvalues,
        liststore,
        entitystore,
        ...custom_modules
      },
      plugins: plugins,
      mutations: mutations
    })

    projects.init(Vue)
    voting.init(Vue)
    meetinglist.init(Vue)
    discussion.init(Vue, store)
    errors.init(Vue)
    liststore.init(Vue)
    entitystore.init(Vue)

    return store
  }
}



// WEBPACK FOOTER //
// ./src/store/index.js